import { TransactionTypeCodeEnum } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import { useMemo } from "react";
var useTransactionType = function (trxTypeCode) {
    return useMemo(function () {
        return [
            TransactionTypeCodeEnum.Redeem,
            TransactionTypeCodeEnum.TransferIn,
        ].includes(trxTypeCode);
    }, [trxTypeCode]);
};
export default useTransactionType;
